export default __webpack_public_path__ + "static/media/ape.cc410349.gif";